// extracted by mini-css-extract-plugin
export default {"savedMethodsSelect":"SavedPaymentMethodsSelect_savedMethodsSelect__pOYhk","title":"SavedPaymentMethodsSelect_title__rL1rS","nullCard":"SavedPaymentMethodsSelect_nullCard__j0NI+"};